import { MetricDetails } from '../../../../api/metrics/types';
import { SQLFilters } from '../../../../api/types';
import { MetricId } from '../../../../api/types-graphql';
import {
  MetricIdType,
  OverTimeTimeSelection,
  SegmentBy,
} from '../../../../types';
import { LanguageString } from '../../dashboards/types';
import { TitleConfig } from '../../ui-components/data-viz-ui/charts/common/common-chart-types';
import {
  BenchmarkPeriods,
  ExternalChartComponentProps,
  OvertimeVizDatapoint,
} from '../common/types';

export type OverTimeSegmentedVizExternalProps = ExternalChartComponentProps;

export interface OverTimeSegmentedVizQuery {
  metric: MetricIdType;
  filters?: SQLFilters;
}

type OverTimeSegmentedBenchmarkConfig = {
  benchmarkPeriod: BenchmarkPeriods;
};

export type OverTimeSegmentedVizConfig = {
  title?: LanguageString;
  subtitle?: LanguageString;
  timeSelection: OverTimeTimeSelection;
  query: OverTimeSegmentedVizQuery;
  segmentBy: SegmentBy;
  benchmarkConfig?: OverTimeSegmentedBenchmarkConfig;
  chartColors?: string[];
  showTotal?: boolean;
};

export type OverTimeSegmentedVizDataResponseForMetricForDateWithoutBenchmark = {
  dateLabel: string;
  datapoints: {
    segmentVal: string | null;
    datapoint: { value: number };
  }[];
};

export type OverTimeSegmentedVizDataResponseForMetricWithoutBenchmark = {
  metric: MetricIdType;
  metricSql: string | null;
  segmentBy: SegmentBy;
  data: OverTimeSegmentedVizDataResponseForMetricForDateWithoutBenchmark[];
};

export type OverTimeSegmentedVizDataResponseForMetricForDate<
  HasBenchmark extends boolean,
> = {
  dateLabel: string;
  datapoints: {
    segmentVal: string | null;
    datapoint: OvertimeVizDatapoint<HasBenchmark>;
  }[];
};

export type OverTimeSegmentedVizDataResponseForMetric<
  HasBenchmark extends boolean = boolean,
> = {
  metric: MetricIdType;
  metricSql: string | null;
  segmentBy: SegmentBy;
  // showing underlying employee data field for cohort segmentation, instead of cohort.cohort_value
  data: OverTimeSegmentedVizDataResponseForMetricForDate<HasBenchmark>[];
};

export type OverTimeSegmentedVizData = {
  dataResponse: OverTimeSegmentedVizDataResponseForMetric;
  titleConfig: TitleConfig;
  metricDisplayValues: Partial<Record<MetricId, string>>;
  metricDetailsMap: Partial<Record<MetricId, MetricDetails>>;
  chartColors?: string[];
  showTotal?: boolean;
};

export enum OverTimeSegmentedVizViews {
  LINE_CHART = 'line-chart',
  BAR_CHART = 'bar-chart',
  TABLE_VIEW = 'table-view',
}
